import useSWRImmutable from "swr/immutable";
import { TEST_ENDPOINT } from "../api/endpoints";
import { BasicPersonalDataFromAPI } from "../api/forms/personal-data/types";
import { Nullable } from "../api/types";
import { fetcher } from "../api/utils";
import useTestId from "./useTestId";

export default function useTestData() {
    const testId = useTestId();

    // Create a unique key that includes location to trigger refetch on navigation
    const swrKey = `test-data-${testId}`;

    const {
        data: value,
        isLoading: loading,
        error,
        mutate,
    } = useSWRImmutable(swrKey, async () => {
        if (!testId) return null;

        const response = (await fetcher(TEST_ENDPOINT, {
            params: { test_id: testId },
        })) as Nullable<BasicPersonalDataFromAPI>;

        if (!response) return null;

        const {
            test_date: testDate,
            test_status: testStatus,
            navbar_status: navbarStatus,
            person: {
                first_name: firstName,
                last_name: lastName,
                age,
                gender,
                weight,
                height,
                bmi,
                fat,
                identification,
            },
        } = response;

        const value = {
            testDate,
            testStatus,
            navbarStatus,
            firstName,
            lastName,
            age,
            gender,
            weight,
            height,
            bmi,
            fat,
            identification,
            testId,
        };
        return value;
    });

    return { value, loading, error, mutate };
}
